import { gql } from '@apollo/client'

export const CHART4_QUERY = gql`
  query processingsClosedCount(
    $showAgents: Boolean
    $filter: ProcessingsClosedCountFilter
    $groupBy: ProcessingsClosedCountGroupBy
  ) {
    processingsClosedCount(showAgents: $showAgents, filter: $filter, groupBy: $groupBy) {
      series {
        color
        title
        usersAverage
        processingTypeAverage
        serie {
          name
          date
          count
        }
      }
    }
  }
`
